/* Standard product DOM adapter; Shopify configuration and native form remain authoritative. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (storefront.product) return;
  storefront.product = { unregister: storefront.lifecycle.register('bs-product', '[data-bs-product]', function(root) {

  let config;
  try { config = JSON.parse(root.querySelector('[data-bs-product-config]').textContent); } catch (error) { return; }
  if (!config || typeof config !== 'object') return;
  const productData = config.product;
  if (!productData || !Array.isArray(productData.variants) || !productData.variants.length || productData.variants.some(variant => !variant || !Number.isSafeInteger(Number(variant.id)) || Number(variant.id) <= 0 || !Number.isInteger(variant.price) || variant.price < 0)) return;
  const scope = root.closest('.shopify-section') || root;
  const productForm = root.querySelector('.product-form-advanced');
  if (!productData || !productForm) return;

  const variantIdInput = productForm.querySelector('.variant-id-input');
  const priceSection = root.querySelector('.product-price-section');
  const mainAddToCartButton = productForm.querySelector('.add-to-cart-btn');
  const mainQtyInput = productForm.querySelector('.quantity-input');

  const stickyBar = scope.querySelector('[id^="stickyAtcBar-"]');
  const stickyQtyInput = scope.querySelector('[id^="stickyAtcQty-"]');
  const stickyButton = scope.querySelector('[id^="stickyAtcButton-"]');
  const stickyPrice = scope.querySelector('[id^="stickyAtcPrice-"]');
  const stickyVariant = scope.querySelector('[id^="stickyAtcVariant-"]');

  const optionSelects = Array.from(productForm.querySelectorAll('.variant-select'));
  const optionButtons = Array.from(productForm.querySelectorAll('.variant-value-btn'));
  const addToCartDefaultText = config.addToCartText;

  const cleanup = [];
  let disposed = false;
  function listen(target, type, handler, options) { const guarded = event => { if (!disposed && root.isConnected !== false) handler(event); }; target.addEventListener(type, guarded, options); cleanup.push(() => target.removeEventListener(type, guarded, options)); }
  try {
  const formatMoney = (amount) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }

    const numericValue = Number(amount || 0) / 100;
    return `$${numericValue.toFixed(2)}`;
  };

  const getVariantById = (id) => productData.variants.find((variant) => String(variant.id) === String(id));

  const getSelectedOptionValues = () => {
    const values = [];

    optionSelects.forEach((select) => {
      const position = Number(select.dataset.optionPosition || 0);
      if (position > 0) {
        values[position - 1] = select.value;
      }
    });

    return values;
  };

  const setSelectsFromVariant = (variant) => {
    if (!variant) return;

    optionSelects.forEach((select) => {
      const position = Number(select.dataset.optionPosition || 0);
      if (position < 1 || position > 3) return;

      const nextValue = variant[`option${position}`];
      if (typeof nextValue === 'string' && nextValue.length) {
        select.value = nextValue;
      }
    });
  };

  const findMatchingVariant = (optionValues) => {
    const matchingVariants = productData.variants.filter((variant) => {
      return optionValues.every((value, index) => {
        if (!value) return true;
        return variant[`option${index + 1}`] === value;
      });
    });

    if (!matchingVariants.length) {
      return null;
    }

    return matchingVariants.find((variant) => variant.available) || matchingVariants[0];
  };

  const syncSwatchStates = () => {
    optionButtons.forEach((button) => {
      const position = Number(button.dataset.optionPosition || 0);
      const select = optionSelects.find((item) => Number(item.dataset.optionPosition || 0) === position);
      const isActive = Boolean(select && select.value === button.dataset.optionValue);

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const syncOptionAvailability = () => {
    const selectedValues = getSelectedOptionValues();

    optionButtons.forEach((button) => {
      const position = Number(button.dataset.optionPosition || 0);
      const value = button.dataset.optionValue || '';
      if (!position || !value) {
        return;
      }

      const candidateValues = [...selectedValues];
      candidateValues[position - 1] = value;

      const hasAvailableVariant = productData.variants.some((variant) => {
        if (!variant.available) {
          return false;
        }

        return candidateValues.every((candidateValue, index) => {
          if (!candidateValue) {
            return true;
          }

          return variant[`option${index + 1}`] === candidateValue;
        });
      });

      button.classList.toggle('is-unavailable', !hasAvailableVariant);
      button.disabled = !hasAvailableVariant;
      button.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
    });
  };

  const updatePriceSection = (variant) => {
    if (!priceSection || !variant) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceSection.innerHTML = `
        <span class="price-compare" style="text-decoration: line-through; opacity: 0.6; margin-right: 10px;">
          ${formatMoney(variant.compare_at_price)}
        </span>
        <span class="price-sale" style="color: ${config.saleColor};">
          ${formatMoney(variant.price)}
        </span>
      `;
    } else {
      priceSection.innerHTML = `<span class="price-regular">${formatMoney(variant.price)}</span>`;
    }
  };

  const updateAvailability = (variant) => {
    const isAvailable = Boolean(variant && variant.available);

    if (mainAddToCartButton) {
      mainAddToCartButton.disabled = !isAvailable;
      mainAddToCartButton.textContent = isAvailable ? addToCartDefaultText : 'Sold Out';
      mainAddToCartButton.style.opacity = isAvailable ? '1' : '0.55';
      mainAddToCartButton.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
    }

    if (stickyButton) {
      stickyButton.disabled = !isAvailable;
      stickyButton.textContent = isAvailable ? addToCartDefaultText : 'Sold Out';
      stickyButton.classList.toggle('is-disabled', !isAvailable);
    }
  };

  const updateStickyMeta = (variant) => {
    if (!stickyBar || !variant) return;

    if (stickyPrice) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        stickyPrice.innerHTML = `<span class="sticky-atc-compare">${formatMoney(variant.compare_at_price)}</span> <span class="sticky-atc-sale">${formatMoney(variant.price)}</span>`;
      } else {
        stickyPrice.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
      }
    }

    if (stickyVariant) {
      const optionValues = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      stickyVariant.textContent = optionValues.join(' / ');
    }
  };

  const applyVariant = (variant, updateMedia) => {
    if (!variant) return;

    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    setSelectsFromVariant(variant);
    syncSwatchStates();
    syncOptionAvailability();
    updatePriceSection(variant);
    updateAvailability(variant);
    updateStickyMeta(variant);

    // Emit only after the native ID, availability and price reflect this variant.
    root.dispatchEvent(new CustomEvent('bs:product-variant', { detail: { variant, updateMedia: Boolean(updateMedia) } }));
  };

  const handleVariantSelectionChange = (updateMedia) => {
    const selectedValues = getSelectedOptionValues();
    let matchingVariant = findMatchingVariant(selectedValues);

    if (!matchingVariant) {
      matchingVariant = productData.variants.find((variant) => variant.available) || productData.variants[0];
    }

    applyVariant(matchingVariant, updateMedia);
  };

  optionButtons.forEach((button) => {
    listen(button, 'click', () => {
      if (button.disabled) return;

      const position = Number(button.dataset.optionPosition || 0);
      const select = optionSelects.find((item) => Number(item.dataset.optionPosition || 0) === position);
      if (!select) return;

      select.value = button.dataset.optionValue;
      handleVariantSelectionChange(true);
    });
  });

  optionSelects.forEach((select) => {
    listen(select, 'change', () => {
      handleVariantSelectionChange(true);
    });
  });

  if (mainQtyInput && stickyQtyInput) {
    stickyQtyInput.value = mainQtyInput.value || '1';

    listen(mainQtyInput, 'input', () => {
      stickyQtyInput.value = mainQtyInput.value || '1';
    });

    listen(stickyQtyInput, 'input', () => {
      const nextValue = Math.max(1, Number(stickyQtyInput.value || 1));
      stickyQtyInput.value = String(nextValue);
      mainQtyInput.value = String(nextValue);
    });
  }

  if (stickyButton && productForm) {
    listen(stickyButton, 'click', () => {
      if (stickyButton.disabled) return;

      if (mainQtyInput && stickyQtyInput) {
        const quantityValue = Math.max(1, Number(stickyQtyInput.value || 1));
        mainQtyInput.value = String(quantityValue);
      }

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    });
  }

  const updateStickyVisibility = () => {
    if (!stickyBar || !mainAddToCartButton) return;

    if (!window.matchMedia('(max-width: 991px)').matches) {
      stickyBar.hidden = true;
      return;
    }

    const buttonRect = mainAddToCartButton.getBoundingClientRect();
    const isMainButtonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
    stickyBar.hidden = isMainButtonVisible;
  };

  let initialVariant = getVariantById(variantIdInput ? variantIdInput.value : '');
  if (!initialVariant) {
    initialVariant = productData.selected_or_first_available_variant || productData.variants[0];
  }

  // A native option may have changed while the deferred asset was loading.
  const changedBeforeMount = initialVariant && optionSelects.some(select => select.value !== initialVariant['option' + select.dataset.optionPosition]);
  if (changedBeforeMount) initialVariant = findMatchingVariant(getSelectedOptionValues()) || initialVariant;
  applyVariant(initialVariant, changedBeforeMount);
  updateStickyVisibility();

  listen(window, 'scroll', updateStickyVisibility, { passive: true });
  listen(window, 'resize', updateStickyVisibility);

  } catch (error) { disposed = true; cleanup.forEach(remove => remove()); throw error; }
  return function dispose() { disposed = true; cleanup.forEach(remove => remove()); if (stickyBar) stickyBar.hidden = true; };
  }) };
})();
